import { EstablishmentProductPriceTableItem } from "../types/establishmentProducts.type"
import { unitiesTranslation } from "@/common/constants/unities.constant"
import UpdatedAtProductPrice from "../components/UpdatedAtProductPrice"
import PriceValueButton from "../components/PriceValueButton"


export class EstablishmentProductPriceTransformer {
  static tableTransformer(clickValueCallback?:Function) {
    return (productsPrices:EstablishmentProductPriceTableItem[]) => {
      return productsPrices.map((price) => ({
        ...price,
        value: (
          <PriceValueButton 
            price={price}
            clickValueCallback={clickValueCallback}
          />
        ),
        category:price.product.category.display_name,
        display_name:price.product.display_name,
        updated_at: <UpdatedAtProductPrice data={price} />,
        unit_for_quantity: unitiesTranslation[price.product.unit_for_quantity as keyof typeof unitiesTranslation],
      }))
    }
  }
}